import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0,
  class: "icon-font svg-icon-custom",
  "aria-hidden": "true"
};
const _hoisted_3 = ["xlink:href"];
const _hoisted_4 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_aside_item = _resolveComponent("aside-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  return !$props.item.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$options.showChildren($props.item) ? (_openBlock(), _createBlock(_component_el_sub_menu, {
    key: 0,
    index: $props.item.name
  }, {
    title: _withCtx(() => [$props.item.meta.icon ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [_createElementVNode("use", {
      "xlink:href": $props.item.meta.icon
    }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.item.meta.title), 1)]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, (subItem, subIdx) => {
      return _openBlock(), _createBlock(_component_aside_item, {
        key: subIdx,
        item: subItem
      }, null, 8, ["item"]);
    }), 128))]),
    _: 1
  }, 8, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
    key: 1,
    index: $props.item.name,
    onClick: _cache[0] || (_cache[0] = $event => $options.handleOpenPage($props.item)),
    style: {
      "background-color": "#1f2d3d"
    }
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString($props.item.meta.title), 1)]),
    default: _withCtx(() => [_createElementVNode("i", {
      class: _normalizeClass($props.item.meta.icon)
    }, null, 2)]),
    _: 1
  }, 8, ["index"]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, (subItem, subIdx) => {
    return _openBlock(), _createBlock(_component_aside_item, {
      key: subIdx,
      item: subItem
    }, null, 8, ["item"]);
  }), 128))]));
}